<template>
    <div class="form-group">
      <label :for="name" class="form-label">{{ label }}</label>
      <div class="select-wrapper">
        <select
          :id="name"
          :name="name"
          class="form-select"
          :value="currentValue"
          @change="handleChange"
          @blur="validateOnBlur"
        >
          <option value="" disabled>Please select</option>
          <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <div class="select-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Dropdown',
    props: {
      name: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      currentValue: {
        type: String,
        default: ''
      },
      options: {
        type: Array,
        required: true
      },
      validate: {
        type: Function,
        default: () => true
      }
    },
    data() {
      return {
        errorMessage: ''
      };
    },
    mounted() {
      this.validateInput(this.currentValue);
    },
    methods: {
      handleChange(event) {
        const value = event.target.value;
        this.$emit('input-changed', value);
        this.validateInput(value);
      },
      
      validateOnBlur(event) {
        this.validateInput(event.target.value);
      },
      
      validateInput(value) {
        const validationResult = this.validate(value);
        
        if (validationResult === true) {
          this.errorMessage = '';
          this.$emit('is-valid', true);
        } else {
          this.errorMessage = validationResult;
          this.$emit('is-valid', false);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
  
  .select-wrapper {
    position: relative;
  }
  
  .form-select {
    display: block;
    width: 100%;
    padding: 0.5rem 2rem 0.5rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    appearance: none;
    background-color: #fff;
  }
  
  .select-arrow {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
    pointer-events: none;
  }
  
  .select-arrow svg {
    height: 1.25rem;
    width: 1.25rem;
    color: #6b7280;
  }
  
  .error-message {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #ef4444;
  }
  </style>